/* global google, GMaps, MarkerClusterer, Swiper */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';
import mapStyles from '../util/mapStyles';

const VenuesSkeleton = () => {
  return (
    <div className="hotel-network-wrapper">
      <h3 className="mb-6 skeleton-shine"/>
      <div className="hotel-wrapper mb-4">
        {Array.from(Array(16).keys()).map((i) => {
          return (
            <div className="result-item skeleton" key={i}>
              <div className="image-wrapper">
                <div className="preview-images skeleton-shine"/>
              </div>
              <div className="content-wrapper">
                <h3 className="result-title skeleton-shine" />
                <div className="result-description skeleton-shine" />
                <div className="result-info">
                  <div className="info-item skeleton-shine" />
                  <div className="info-item skeleton-shine" />
                  <div className="info-item skeleton-shine" />
                  <div className="info-item skeleton-shine" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

class AppGlobalHostEventSearch extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      viewType: 'list',
      loading: true,
      results: [],
      resultLocations: [],
      heading: '',
      subHeading: '',
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
    this.occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
    this.guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

    // Bind "this"
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
    this.loadMap = this.loadMap.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load results on first page load
    this.loadSearchResults();

    // Reload results on input changes
    document.addEventListener(constants.EVENT_SUBMIT_CLICKED_SEARCH, () => {
      const location = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
      const occasion = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
      const guests = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_GUESTS);

      if (this.location !== location || this.occasion !== occasion || this.guests !== guests) {
        this.location = location;
        this.occasion = occasion;
        this.guests = guests;
        this.loadSearchResults();
      }
    });

    $(document).on(constants.EVENT_VIEW_TYPE_CHANGED, (e, viewType) => {
      this.setState({viewType});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      const resultsCount = $('h2.results-count');
      if (resultsCount.length) {
        if (this.state.loading) {
          resultsCount.text('');
        } else {
          resultsCount.text(this.state.heading);
        }
      }
    }

    if (
      (prevState.loading && !this.state.loading && this.state.viewType === 'map') ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading && this.state.viewType === 'map') ||
      (!this.state.loading && prevState.viewType !== 'map' && this.state.viewType === 'map')
    ) {
      this.loadMap();
    }

    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading) ||
      (!this.state.loading && prevState.viewType !== 'list' && this.state.viewType === 'list')
    ) {
      setTimeout(() => {
        // Equal height for elements
        $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
      }, 200);
    }
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState({
      loading: true,
      results: [],
      resultLocations: [],
      heading: '',
      subHeading: '',
      loadMoreLoading: false,
      loadedAll: false,
    });

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_VENUES,
      'location': this.location,
      'occasion': this.occasion,
      'guests': this.guests,
      'offset': 0,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const hotelsCount = response.data['hotels_count'];
          const venuesCount = response.data['venues_count'];
          const hotelVenues = [...response.data['venues']];
          const hotelLocations = [...response.data['hotel_locations']];

          if (0 === venuesCount) {
            this.setState({
              heading: 'Oops',
              subHeading: 'No venues found',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          } else {
            this.setState({
              loading: false,
              results: hotelVenues,
              resultLocations: hotelLocations,
              heading: `${venuesCount}` + (1 === venuesCount ? ' Venue' : ' Venues'),
              subHeading: '',
              loadMoreLoading: false,
              loadedAll: hotelsCount == hotelVenues.length,
            });
          }
        } else {
          this.setState({
            heading: 'Oops',
            subHeading: 'Something went wrong.',
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreSearchResults(e) {
    e.preventDefault();

    const {
      results,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_VENUES,
        'location': this.location,
        'occasion': this.occasion,
        'guests': this.guests,
        'offset': results.length,
      };

      // Send request
      axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const hotelsCount = response.data['hotels_count'];
            const hotelVenues = [
              ...results,
              ...response.data['venues'],
            ];

            this.setState({
              loading: false,
              results: hotelVenues,
              loadMoreLoading: false,
              loadedAll: hotelsCount == hotelVenues.length,
            });
          } else {
            this.setState({
              heading: 'Oops',
              subHeading: 'Something went wrong.',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  loadMap() {
    if ($('#hotels-map-wrapper').length) {
      const { resultLocations } = this.state;
      if (resultLocations.length > 0) {
        // Setup first item on map
        const map = new GMaps({
          div: '#hotels-map-wrapper',
          scrollwheel: false,
          center: new google.maps.LatLng(resultLocations[0]['location']['lat'], resultLocations[0]['location']['lng']),
          zoom: 15,
          markerClusterer: function(map) {
            return new MarkerClusterer(map, null, {
              styles: [
                {
                  textColor: 'white',
                  textSize: 20,
                  url: window.Ode['assetsPath'] + 'images/map-markers/blank.svg',
                  height: 62,
                  width: 62,
                },
              ],
            });
          },
          styles: mapStyles,
        });

        const mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();
        const bounds = [];

        for (let i = 0; i < resultLocations.length; i++) {
          if (Object.keys(resultLocations[i]['location']).length > 0) {
            const title = resultLocations[i]['title'];
            const lat = resultLocations[i]['location']['lat'];
            const lng = resultLocations[i]['location']['lng'];
            const link = resultLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                scaledSize: new google.maps.Size(44, 44),
                url: window.Ode['assetsPath'] + 'images/map-markers/default.svg',
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  image: resultLocations[i]['image'],
                  address: resultLocations[i]['address'],
                  link,
                }, mapMarkerInfoWindowTemplate),
              },
            });
          }
        }

        if (resultLocations.length > 1) {
          map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  render() {
    const {
      viewType,
      loading,
      results,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        {
          viewType === 'list' && (
            <React.Fragment>
              <div className="results-container">
                {
                  !loading && results.length > 0 && (
                    results.map((venue, i) => {
                      return (
                        <div key={i} className="hotel-network-wrapper mb-12">
                          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-6">
                            <h3 className="mb-2">{venue['location']}</h3>
                            {
                              venue['venues_overview_url'].length > 0 && (
                                <a href={venue['venues_overview_url']} className="btn pr-2">
                                  All Venues
                                </a>
                              )
                            }
                          </div>
                          <div className="hotel-wrapper mb-4">
                            {
                              venue['function_rooms'].map((room, j) => {
                                return (
                                  <div key={j} className="result-item">
                                    <div className="image-wrapper">
                                      {
                                        room['images'].length > 0 && (
                                          <div className="preview-images">
                                            <div className="swiper-container">
                                              <div className="swiper-wrapper">
                                                {
                                                  room['images'].map((image, k) => {
                                                    return (
                                                      <div className="swiper-slide" key={k}>
                                                        <a href={room['url']} className="slide bg-center bg-no-repeat bg-cover" style={{backgroundImage: `url(${image})`}} />
                                                      </div>
                                                    );
                                                  })
                                                }
                                              </div>
                                            </div>
                                            <div className="swiper-navigation">
                                              <button type="button" data-role="none" className="prev" aria-label="Prev" tabIndex="0" role="button">
                                                <img className="img-fluid" src={window.Ode['assetsPath'] + 'images/icons/left-chevron-circle.svg'} alt="Prev"/>
                                              </button>
                                              <button type="button" data-role="none" className="next" aria-label="Next" tabIndex="1" role="button">
                                                <img className="img-fluid" src={window.Ode['assetsPath'] + 'images/icons/right-chevron-circle.svg'} alt="Next"/>
                                              </button>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                    <div className="content-wrapper">
                                      <h3 className="result-title" dangerouslySetInnerHTML={{__html: room['name']}} />
                                      <div className="result-description">
                                        <p dangerouslySetInnerHTML={{ __html: room['description'] }}></p>
                                      </div>
                                      <div className="result-info">
                                        {
                                          room['area'].length > 0 && (
                                            <div className="info-item">
                                              <span className="label">Area :</span>
                                              {room['area']}&nbsp;m<sup>2</sup>
                                            </div>
                                          )
                                        }
                                        {
                                          room['capacity'].length > 0 && (
                                            <div className="info-item">
                                              <span className="label">Max capacity :</span>
                                              {room['capacity']}
                                            </div>
                                          )
                                        }
                                        {
                                          room['classroom_capacity'].length > 0 && (
                                            <div className="info-item">
                                              <span className="label">Chair :</span>
                                              {room['classroom_capacity']}
                                            </div>
                                          )
                                        }
                                        {
                                          room['cocktail_capacity'].length > 0 && (
                                            <div className="info-item">
                                              <span className="label">Person :</span>
                                              {room['cocktail_capacity']}
                                            </div>
                                          )
                                        }
                                      </div>
                                      <a href={room['url']} className="btn btn-cta">View details</a>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      );
                    })
                  )
                }
                {
                  (loading || loadMoreLoading) && (
                    <VenuesSkeleton/>
                  )
                }
              </div>
              <div className="results-wrapper-cta">
                <button className="btn btn-outline-black btn-load-more mt-4 px-12" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreSearchResults}>
                  {!loadedAll ? 'Load More' : 'That\'s All'}
                </button>
              </div>
            </React.Fragment>
          )
        }
        {
          viewType === 'map' && (
            <React.Fragment>
              {
                !loading
                  ? (
                    <div id="hotels-map-wrapper" className="map-wrapper" />
                  ) : (
                    <MapSkeleton />
                  )
              }
            </React.Fragment>
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded
    // Results
    const resultsWrapper = $('#search-venues-results-wrapper');
    if (resultsWrapper.length) {
      setTimeout(function() {
        ReactDOM.render(<AppGlobalHostEventSearch/>, resultsWrapper[0]);
      }, 1000);
    }

    const searchVenuesFormWrapper = $('.search-venues-form-wrapper');

    if (searchVenuesFormWrapper.length) {
      const venueLocationsSearch = searchVenuesFormWrapper.find('.location-search');
      const venueOccasionsSearch = searchVenuesFormWrapper.find('.occasions-search');
      const venueLocation = helpers.getParameterByName('location');
      const venueOccasion = helpers.getParameterByName('occasion');
      const venueLocationCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_LOCATION);
      const venueOccasionCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_VENUES_SEARCH_OCCASION);
      const params = helpers.getParameters();

      // Set url params to cookie
      if (venueLocation != null && venueLocation.length) {
        params['location'] = venueLocation;
        venueLocationsSearch.val(venueLocation);
        helpers.docCookies.setItem(venueLocationsSearch.data('cookie-location'), venueLocation, 1500, '/');
      }
      if (venueOccasion != null && venueOccasion.length) {
        params['occasion'] = venueOccasion;
        venueOccasionsSearch.val(venueOccasion);
        helpers.docCookies.setItem(venueOccasionsSearch.data('cookie-occasion'), venueOccasion, 1500, '/');
      }

      // Set cookie to url params
      if ((venueLocation == null && venueLocationCookie) || (venueOccasion == null && venueOccasionCookie)) {
        if (venueLocationsSearch.length && venueLocation == null && venueLocationCookie) {
          params['location'] = venueLocationCookie;
        }
        if (venueOccasionsSearch.length && venueOccasion == null && venueOccasionCookie) {
          params['occasion'] = venueOccasionCookie;
        }
      }

      // Push params to url
      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

      const handleUrlParamsOnInput = function() {
        const params = helpers.getParameters();

        if (venueLocationsSearch.length && venueLocationsSearch.val() !== '') {
          params['location'] = venueLocationsSearch.val();
        } else {
          delete params['location'];
        }
        if (venueOccasionsSearch.length && venueOccasionsSearch.val() !== '') {
          params['occasion'] = venueOccasionsSearch.val();
        } else {
          delete params['occasion'];
        }

        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
      };

      const submitButton = searchVenuesFormWrapper.find('button[type="submit"]');

      searchVenuesFormWrapper.find('.where, .occasion, .guest')
        .on('input', function() {

          const _this = $(this);

          if (_this.val().length === 0) {
            handleUrlParamsOnInput();

            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          handleUrlParamsOnInput();

          submitButton.prop('disabled', false);
        });

      // Trigger search on submit button clicked
      let timeout;
      submitButton.on('click', function(e) {
        e.preventDefault();

        clearTimeout(timeout);

        timeout = setTimeout(function() {
          document.dispatchEvent(helpers.initNewEvent(constants.EVENT_SUBMIT_CLICKED_SEARCH));
        }, 1000);
      });
    }

    // View types
    const hotelViewTypes = $('#hotel-view-types');
    if (hotelViewTypes.length) {
      const viewTypeItem = hotelViewTypes.find('.view-type-item');

      viewTypeItem.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const view = _this.data('view');

        viewTypeItem.removeClass('active');
        _this.addClass('active');

        $(document).trigger(constants.EVENT_VIEW_TYPE_CHANGED, [view]);
      });
    }

    // Trigger swiper on results loaded
    const loadVenueSlider = () => {
      const previewImages = $('.preview-images');
      if (previewImages.length) {
        previewImages.each(function() {
          const _this = $(this);
          const swiperContainer = _this.find('.swiper-container');

          if (!swiperContainer.hasClass('swiper-container-initialized')) {
            const prevBtn = _this.find('.swiper-navigation .prev').get(0);
            const nextBtn = _this.find('.swiper-navigation .next').get(0);

            new Swiper(swiperContainer.get(0), {
              loop: true,
              slidesPerView: 1,
              navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
              },
            });
          }
        });
      }
    };

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, loadVenueSlider);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventSearch.js